import React from 'react';

const AsyncCorpusKeyword = React.lazy(() => import('./CorpusKeywordContainer'));
export const CorpusKeywordPage = () => {
  return <AsyncCorpusKeyword />;
};
